import React from "react";
import AppLayout from "../components/AppLayout";

export default function Plano() {
  return (
    <AppLayout>
      <div className="titulo-com-acao">
        <div>
          <p className="sobretitulo">Acesso profissional</p>
          <h1>Gratuito neste momento</h1>
          <p>Use os recursos do DiárioMed no seu trabalho sem cobrança.</p>
        </div>
      </div>
      <section className="grid-acompanhamentos">
        <article className="acompanhamento">
          <span className="badge">Plano atual</span>
          <h2>Profissional gratuito</h2>
          <p><strong>R$ 0</strong></p>
          <p>Crie acompanhamentos, convide pacientes, organize registros e consulte relatórios sem limite de tempo.</p>
          <p>Não há cobrança recorrente nem checkout ativo.</p>
        </article>
      </section>
    </AppLayout>
  );
}
